import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PerfilUsuarioComponent } from './perfil-usuario/perfil-usuario.component';
import { ActividadDetalleComponent } from './actividad-detalle/actividad-detalle.component';
import { CheckDataComponent } from './check-data/check-data.component';
import { HacerseSocioComponent } from './hacerse-socio/hacerse-socio.component';
import { AdminDatosEntidadComponent } from './admin-datos-entidad/admin-datos-entidad.component'
import { ProcesoCompraComponent } from './proceso-compra/proceso-compra.component'
import { CambiarPasswordComponent } from './cambiarPassword/cambiar-password.component';
import { InformesComponent } from './informes/informes.component';
import { PestaniaSocialComponent } from './pestaniaSocial/pestania-social.component';
import { AdminForosComponent } from './admin-foros/admin-foros.component';
import { AdminSubForosComponent } from './admin-subforos/admin-subforos.component';
import { AdminTemasComponent } from './admin-temas/admin-temas.component';
import { UserForosComponent } from './user-foros/user-foros.component';
import { UserSubForosComponent } from './user-subforos/user-subforos.component';
import { UserTemasComponent } from './user-temas/user-temas.component';
import { AceptarTemasComponent } from './aceptar-temas/aceptar-temas.component';
import { ForosMensajesComponent } from './foros-mensajes/foros-mensajes.component';
import { MuroPersonalComponent } from './muroPersonal/muro-personal.component';
import { MuroUsuariosComponent } from './muroUsuarios/muro-usuarios.component';
import { MuroFormativoComponent } from './muroFormativo/muro-formativo.component';
import { MuroSocialFormativoComponent } from './muroSocialFormativo/muroSocial-formativo.component';
import { MuroGrupoTrabajoAComponent } from './muroGrupoTrabajoAdmin/muro-trabajoA.component';
import { MuroGrupoTrabajoUsuariosComponent } from './muroGrupoTrabajoUsuarios/muro-trabajoUser.component';
import { MuroGrupoTrabajoComponent } from './muroGrupoTrabajo/muro-grupoTrabajo.component';
import { BuscadorComponent } from './Buscador/buscador.component';
import { AdminBajaSocialComponent } from './admin-bajaSocial/admin-bajaSocial.component';

const routes: Routes = [{
  path: '',
  component: PagesComponent,
  children: [{
    path: 'perfil-usuario',
    component: PerfilUsuarioComponent,
  },{
    path: 'admin-datos-entidad',
    component: AdminDatosEntidadComponent,
  },{
    path: 'admin-foros',
    component: AdminForosComponent,
  },{
    path: 'admin-subforos',
    component: AdminSubForosComponent,
  },{
    path: 'admin-temas',
    component: AdminTemasComponent,
  },{
    path: 'user-foros',
    component: UserForosComponent,
  },{
    path: 'user-subforos',
    component: UserSubForosComponent,
  },{
    path: 'user-temas',
    component: UserTemasComponent,
  },{
    path: 'aceptarTema',
    component: AceptarTemasComponent,
  },{
    path: 'foros-mensajes',
    component: ForosMensajesComponent,
  },{
    path: 'muro-personal',
    component: MuroPersonalComponent,
  },{
    path: 'muro-usuarios',
    component: MuroUsuariosComponent,
  },{
    path: 'muro-formativo',
    component: MuroFormativoComponent,
  },{
    path: 'muro-actividad',
    component: MuroSocialFormativoComponent,
  },{
    path: 'muro-trabajoA',
    component: MuroGrupoTrabajoAComponent,
  },{
    path: 'muro-trabajoU',
    component: MuroGrupoTrabajoUsuariosComponent,
  },{
    path: 'muro-grupo',
    component: MuroGrupoTrabajoComponent,
  },{
    path: 'buscador',
    component: BuscadorComponent,
  },{
    path: 'admin-bajaSocial',
    component: AdminBajaSocialComponent,
  },{
    path: 'actividad-detalle',
    component: ActividadDetalleComponent,
  },{
    path: 'check-data',
    component: CheckDataComponent,
  }, {
    path: 'control-panel',
    component: DashboardComponent,
  },{
    path: 'listados',
    loadChildren: './listados/listados.module#ListadosModule',
  },
  {    
    path: 'informes',
    component: InformesComponent,
  },{
    path: 'hacerse-socio',
    component: HacerseSocioComponent,
  },{
    path: 'proceso-compra',
    component: ProcesoCompraComponent,
  },
  {
    path: 'cambiar-password',
    component: CambiarPasswordComponent,
  },
  {
    path: 'pestania-social',
    component: PestaniaSocialComponent,
  }]
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
